import { createApp } from 'vue';
import App from './App.vue';
import { VjComponents, iconRegistry } from '@vanjana/vue-ui';

import PowerOff from '@/components/PowerOff.vue'

// Import Light Theme and FontAwesome Icons
import '@vanjana/vue-ui/theme-light';
import '@vanjana/vue-ui/vue-ui';
import './styles/styles.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

iconRegistry.registerComponent('poweroff', PowerOff);

const app = createApp(App);
app.use(VjComponents);
app.mount('#app');
